module.exports = __webpack_public_path__ + "media/images/dashboard/stride-banner-bg-98c289d393043868465d334d0a28a968.jpg";